'use client';

import { useState } from 'react';
import { DemoShell } from '@/components/demo/DemoShell';
import { ProjectList } from '@/components/demo/ProjectList';
import { SpecView } from '@/components/demo/SpecView';
import { Project } from '@/components/demo/mockData';

type View = 'projects' | 'spec';

export default function DemoPage() {
  const [currentView, setCurrentView] = useState<View>('projects');
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  const handleSelectProject = (project: Project) => {
    setSelectedProject(project);
    setCurrentView('spec');
  };

  const handleBack = () => {
    setCurrentView('projects');
    setSelectedProject(null);
  };

  return (
    <main className="min-h-screen bg-bg py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-text mb-2">Product Demo</h1>
          <p className="text-text-muted max-w-2xl mx-auto">
            Explore the SpecLedger workflow: track projects, manage specifications,
            and keep your team aligned from requirements to implementation.
          </p>
        </div>

        {/* Demo Container */}
        <DemoShell
          currentView={currentView}
          projectName={selectedProject?.name}
          specName={selectedProject?.activeSpec}
        >
          {currentView === 'projects' ? (
            <ProjectList onSelectProject={handleSelectProject} />
          ) : selectedProject ? (
            <SpecView project={selectedProject} onBack={handleBack} />
          ) : null}
        </DemoShell>

        {/* Instructions */}
        <div className="mt-8 text-center text-text-muted text-sm">
          <p>Click on a project to view its specification details.</p>
          <p>Switch between Artifacts, Issues, and Changes tabs to explore the workflow.</p>
        </div>
      </div>
    </main>
  );
}
